<template>
    <base-dialog ref="base" max-width="600">
        <v-card>
            <v-card-title>
                Публикация
                <span v-if="current_client.provider === 'vk-oauth2'" class="ml-2"
                      style="color: #4a76a8">ВКОНТАКТЕ</span>
                <span v-else class="ml-2" style="color: #ee8208">ОДНОКЛАССНИКИ</span>
            </v-card-title>
            <v-card-text>
                <v-row justify="center" align="center">
                    <v-col class="text-center" style="max-width: 224px">
                        <v-img style="cursor: pointer; max-width: 200px"
                               :src="collection.image_url"></v-img>
                    </v-col>
                    <v-col style="min-width: 250px">
                        <v-textarea no-resize v-model="options.comment" label="Описание" outlined
                                    hide-details
                                    rows="5"></v-textarea>
                    </v-col>
                </v-row>

                <v-radio-group @change="onChangePlace" v-model="options.place" hide-details class="mt-0"
                               label="Место публикации:">
                    <v-radio :value="'wall'" label="На своей стене"></v-radio>
                    <v-radio :value="'album'" label="В свой альбом"></v-radio>
                    <v-radio :value="'group_wall'" label="На стене сообщества"></v-radio>
                    <v-radio :value="'group_album'" label="В альбом сообщества"></v-radio>
                </v-radio-group>

                <v-autocomplete
                    v-if="['group_wall', 'group_album'].includes(options.place)"
                    class="mt-4"
                    dense hide-details
                    outlined
                    label="Сообщество"
                    no-data-text="Нет групп"
                    :items="groups"
                    v-model="options.group_id"
                    @change="onGroupSelect"
                    :loading="loading_groups"
                ></v-autocomplete>

                <v-autocomplete
                    v-if="['album', 'group_album'].includes(options.place)"
                    class="mt-4"
                    dense hide-details
                    outlined
                    label="Альбом"
                    no-data-text="Нет альбомов"
                    item-text="text"
                    item-value="value"
                    :items="albums"
                    v-model="options.album_id"
                    :loading="loading_albums"
                ></v-autocomplete>

                <v-row class="mt-4">
                    <v-col class="text-right">
                        <v-btn @click="$refs.base.hide()" class="btn mr-2">Отмена</v-btn>
                        <v-btn class="btn" :disabled="disable" :loading="loading_publication" @click="onPublication"
                               color="primary">
                            Публикация
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </base-dialog>
</template>

<script>
import EventBus from "@/event-bus";
import BaseDialog from "@/components/utils/BaseDialog";
import Vue from "vue";
import { mapState } from "vuex";

export default {
    name: "PublicationDialog",
    components: {BaseDialog},
    data() {
        return {
            loading_albums: false,
            loading_groups: false,
            loading_publication: false,
            options: {
                comment: '',
                place: 'wall',
                album_id: undefined,
                group_id: undefined,
            },
            collection: {},
            albums: [],
            groups: []
        }
    },
    computed: {
        ...mapState('clients', [
            'current_client'
        ]),
        disable() {
            return (this.options.place === 'album' && !this.options.album_id) ||
                (this.options.place === 'group_album' && (!this.options.group_id || !this.options.album_id)) ||
                (this.options.place === 'group_wall' && !this.options.group_id)
        }
    },
    methods: {
        onGroupSelect() {
            this.getAlbums()
        },
        onChangePlace(val) {
            if (['album', 'group_album'].includes(val)) {
                this.getAlbums()
            }
            if (['wall', 'album'].includes(val)) {
                this.options.group_id = undefined
                this.options.album_id = undefined
            }
        },
        getAlbums() {
            if (this.current_client.provider === 'vk-oauth2') {
                this.getVkAlbums()
            } else {
                this.getOkAlbums()
            }
        },
        getOkAlbums() {
            const vm = this
            let group_id
            if (vm.options.group_id && vm.options.place !== 'album') {
                group_id = vm.options.group_id
            }
            vm.albums = []
            vm.loading_albums = true
            vm.$store.dispatch('ok/getAlbums', {group_id})
                .then(albums => {
                    vm.albums = []
                    albums.forEach(obj => {
                        vm.albums.push({
                            text: obj.title,
                            value: obj.aid,
                        })
                    })
                })
                .finally(() => vm.loading_albums = false)
        },
        getVkAlbums() {
            const vm = this
            let owner_id
            if (vm.options.group_id && vm.options.place !== 'album') {
                owner_id = `-${vm.options.group_id}`
            }
            vm.albums = []
            vm.loading_albums = true
            vm.$store.dispatch('vk/getAlbums', {owner_id})
                .then(albums => {
                    vm.albums = []
                    albums.forEach(obj => {
                        vm.albums.push({
                            text: obj.title,
                            value: obj.id,
                        })
                    })
                })
                .finally(() => vm.loading_albums = false)
        },
        getGroups() {
            if (this.current_client.provider === 'vk-oauth2') {
                this.getVkGroups()
            } else {
                this.getOkGroups()
            }
        },
        getOkGroups() {
            const vm = this
            vm.groups = []
            vm.loading_groups = true
            vm.$store.dispatch('ok/getGroups')
                .then(groups => {
                    groups.forEach(obj => {
                        vm.groups.push({
                            text: obj.name,
                            value: obj.uid,
                        })
                    })
                })
                .finally(() => vm.loading_groups = false)
        },
        getVkGroups() {
            const vm = this
            vm.groups = []
            vm.loading_groups = true
            vm.$store.dispatch('vk/getGroups')
                .then(groups => {
                    groups.forEach(obj => {
                        vm.groups.push({
                            text: obj.name,
                            value: obj.id,
                        })
                    })
                })
                .finally(() => vm.loading_groups = false)
        },
        onPublication() {
            if (this.current_client.provider === 'vk-oauth2') {
                this.onVkPublication()
            } else {
                this.onOkPublication()
            }
        },
        onOkPublication() {
            const vm = this
            vm.loading_publication = true
            vm.$store.dispatch('ok/publication', {options: vm.options})
                .then(post_data => {
                    if (post_data) {
                        let params = ['source=ok']
                        for (let key in post_data) {
                            params.push(`${key}=${encodeURIComponent(post_data[key])}`)
                        }
                        const url = 'https://posred.ru/publication?' + params.join('&')
                        window.open(url, '_blank')
                    }
                    Vue.toasted.show(`Публикация прошла успешно!  🥰`, {
                        type: 'success',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    }).goAway(10000);
                    vm.$refs.base.hide()
                })
                .finally(() => vm.loading_publication = false)
        },
        onVkPublication() {
            const vm = this
            vm.loading_publication = true
            vm.$store.dispatch('vk/publication', {options: vm.options})
                .then(post_data => {
                    if (post_data) {
                        let params = ['source=vk']
                        for (let key in post_data) {
                            params.push(`${key}=${encodeURIComponent(post_data[key])}`)
                        }
                        const url = 'https://posred.ru/publication?' + params.join('&')
                        window.open(url, '_blank')
                    }
                    Vue.toasted.show(`Публикация прошла успешно!  🥰`, {
                        type: 'success',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    }).goAway(10000);
                    vm.$refs.base.hide()
                })
                .finally(() => vm.loading_publication = false)
        }
    },
    created() {
        const vm = this
        EventBus.$on('publication-dialog', ({collection, comment}) => {

            vm.collection = collection

            vm.options = {
                comment: `${collection.description}\n\nСбор #${collection.id}\nЦена: ${collection.trade_price}₽\n${comment}`,
                place: 'wall',
                album_id: undefined,
                group_id: undefined,
                collection_id: collection.id
            }

            vm.loading_publication = false

            if (vm.$refs.base !== undefined) {

                vm.getGroups()

                vm.$refs.base.show()
            }
        })
    }
}
</script>